module.exports = __webpack_public_path__ + "img/43_66.a50cbc34.png";